module.exports = __webpack_public_path__ + "img/MaxCrot.827678ce.png";